var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { getImageInfo } from '@docext/algolib';
import { uploadV1 } from '../client/UploadV1';
import { isRaster } from './utility';
const MAX_IMAGE_SIZE = 1; // in MB
const MAX_IMAGE_DIMENSION = 1024;
export function shouldGenerateImagePreview(file) {
    const maxAllowedSize = MAX_IMAGE_SIZE * 1024 * 1024; // in bytes
    return file.size > maxAllowedSize;
}
export function generateImagePreview(file, headers) {
    if (!file) {
        throw new Error(`File is empty`);
    }
    if (!isRaster(file)) {
        throw new Error(`file is not supported`);
    }
    return new Promise((resolve) => {
        try {
            const img = document.createElement('img');
            const blobUrl = URL.createObjectURL(file);
            const canvas = document.createElement('canvas');
            const ctx = canvas.getContext('2d');
            img.onload = () => __awaiter(this, void 0, void 0, function* () {
                try {
                    let scalingFactor;
                    if (img.height > img.width) {
                        scalingFactor = MAX_IMAGE_DIMENSION / img.height;
                    }
                    else {
                        scalingFactor = MAX_IMAGE_DIMENSION / img.width;
                    }
                    const previewHeight = img.height * scalingFactor;
                    const previewWidth = img.width * scalingFactor;
                    canvas.height = previewHeight;
                    canvas.width = previewWidth;
                    if (!ctx)
                        return;
                    ctx.drawImage(img, 0, 0, previewWidth, previewHeight);
                    const imgData = ctx.getImageData(0, 0, ctx.canvas.width, ctx.canvas.height);
                    ctx.putImageData(imgData, 0, 0);
                    yield canvas.toBlob((blob) => __awaiter(this, void 0, void 0, function* () {
                        if (blob) {
                            const uploadV1Response = yield uploadV1({
                                headers,
                                file: blob,
                            });
                            resolve(uploadV1Response.data);
                            return;
                        }
                        Promise.reject(new Error('some error ocurred'));
                    }), 'image/webp');
                }
                catch (exception) {
                    throw new Error('Exception while processing imageInfo on Image Load');
                }
            });
            img.onerror = () => {
                throw new Error('Error while fetching image');
            };
            img.src = blobUrl;
        }
        catch (exception) {
            throw new Error('Exception while processing imageInfo');
        }
    });
}
/**
 * @deprecated The method should not be used Please use getImageInfo directly .
 */
export function getImageInfoByClassification(file) {
    if (!file) {
        throw new Error(`File is empty`);
    }
    if (!isRaster(file)) {
        throw new Error(`file is not supported`);
    }
    return getImageInfo(file);
}
//# sourceMappingURL=imageClassification.js.map